<template>
    <Field
           :labelFor="name"
           :title="title"
           :description="description"
           :helpText="helpText"
           :errorMessage="errorMessage"
           :required="required"
    >
        <template v-slot:input>
            <div class="form__group">
                <input type="number" @change="formatInput" min="0" max="31" maxlength="2" placeholder="DD" v-model="day" class="form__control form__control--date"> /
                <input type="number" @change="formatInput" min="0" max="12" maxlength="2" placeholder="MM" v-model="month" class="form__control form__control--date"> /
                <input type="number" @change="formatInput" min="0" max="9999" maxlength="4" placeholder="YYYY" v-model="year" class="form__control form__control--date">
            </div>

            <!--<datetime-->
                    <!--v-model="model"-->
                    <!--:input-class="'form__control'"-->
                    <!--value-zone="Europe/Brussels"-->
                    <!--format="dd/MM/yyyy"-->
                    <!--:flow="['year', 'date']"-->
                    <!--auto-->
            <!--&gt;-->
                <!--<template slot="button-cancel">-->
                    <!--<T>Annuleren</T>-->
                <!--</template>-->
                <!--<template slot="button-confirm">-->
                    <!--<T>Bevestigen</T>-->
                <!--</template>-->

            </datetime>
        </template>
    </Field>
</template>

<script>
    import FieldMixin from '../../mixins/FieldMixin'
    import moment from 'moment'
    import { Settings } from 'luxon'

    export default {
        name: 'FieldDate',
        mixins: [
            FieldMixin
        ],
        data () {
            return {
                day: null,
                month: null,
                year: null,
            }
        },
        model: {
            prop: 'value',
            event: 'update'
        },
        methods: {
            activeLang(lang) {
                Settings.defaultLocale = lang;
            },
            formatInput() {
                this.$emit("update", this.day + '/' + this.month + '/' + this.year);
            }
        },
        created: function() {
            this.val = moment(this.value,'DD/MM/YYYY');
            this.day = this.val.format('DD');
            this.month = this.val.format('MM');
            this.year = this.val.format('YYYY');

            this.activeLang(this.$store.state.activeLocale);
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/form/components/fields/FieldDate.vue